import { createStateContext } from '@change-corgi/core-react/context';

import { INITIAL_STATE } from './initialState';
import { mutations } from './mutations';
import type { PsfSharePageState } from './types';

/** @knip-ignore */
export const {
	StateContext: PsfSharePageStateContext,
	StateProvider: PsfSharePageStateContextProvider,
	useStateContext: usePsfSharePageState,
} = createStateContext<PsfSharePageState, typeof mutations>({
	name: 'PsfSharePageStateContext',
	mutations,
	initialState: INITIAL_STATE,
});
